import type { HTMLText } from '../../../amplienceTypes/schemas/exported/html-text-schema';
import type { ReactElement } from 'react';

import { useMemo } from 'react';

import Attributes from '../partials/Attributes';
import { parseHtmlWithFesLinks } from '~/components/shared/core/link/parseHtmlWithFesLinks';
import { getAmplienceMeta } from '~/utilities/amplience';

export const HtmlText = ({ content, attributes, _meta }: HTMLText): ReactElement => {
  const html = content?.htmlEditor?.html as string | undefined;
  const parsedHtmlContent = useMemo(() => (html ? parseHtmlWithFesLinks(html) : undefined), [html]);

  return parsedHtmlContent ? (
    <Attributes
      {...attributes}
      {...getAmplienceMeta(_meta).metaAttributes}
      additionalClassNames="contentBlock js-contentBlock contentBlock--longCopy"
    >
      <div className="contentBlock-body js-contentBlock-body">
        <div className="contentBlock-bodyAlign">
          <div
            className="contentBlock-body-text js-contentBlock-body-text"
            suppressHydrationWarning
          >
            {parsedHtmlContent}
          </div>
        </div>
      </div>
    </Attributes>
  ) : (
    <></>
  );
};
